<template>
  <div class="detect">
    <div class="bg">
      <div class="main-content">
        <start-page v-if="curStep === 0" @nextStep="nextStep" :detect-types="deviceTypes"></start-page>
        <about-pc v-if="curStep === 1" @nextStep="nextStep" @setPcInfo="setPcInfo"></about-pc>
        <camera v-if="curStep === 2" @nextStep="nextStep" @setCameraInfo="setCameraInfo"></camera>
        <detect-micro v-if="curStep === 3" @nextStep="nextStep" @setMicroInfo="setMicroInfo"></detect-micro>
        <result v-if="curStep === 4"
                @nextStep="nextStep"
                :pcInfo="pcInfo"
                :goExam="goExam"
                :detectOs="detectOs"
                :detectVersion="detectVersion"
                :detectSpeed="detectSpeed"
                :osTip="osTip"
                :versionTip="versionTip"
                :speedTip="speedTip"
                :detect-types="deviceTypes"
                ></result>
        <div class="loading-mask" v-if="loading">
          <loading
            :box-size="16"
            :round-size="4"
            :color="'#306FFF'"></loading>
        </div>
      </div>
    </div>
    <quit-tip-modal v-show="showQuitTip" @close="closeModal" @quit="quit"></quit-tip-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StartPage from './StartPage'
import AboutPc from './AboutPc'
import DetectMicro from './DetectMicro'
import Result from './Result'
import Camera from './Camera'
import { post } from '@/utils/ajax'
import QuitTipModal from './QuitTipModal'
import Loading from '@/components/Loading'
import { mediaInfo } from '@/utils/common'
export default {
  components: {
    StartPage,
    AboutPc,
    Camera,
    DetectMicro,
    Result,
    QuitTipModal,
    Loading
  },
  data() {
    return {
      status: {
        normal: 1,
        pass: 2,
        error: 0
      },
      // --- 检测报告
      detectOs: 1,
      detectVersion: 1,
      detectSpeed: 1,
      osTip: '',
      versionTip: '',
      speedTip: '',
      // --- 检测报告
      goExam: false, // 没有可参加的考试
      loading: false,
      errorArr: [], // 用来存错误的 啥1234... 说明在这https://shimo.im/docs/9xWKRgV986gDjDpG/read
      curStep: 0,
      pcInfo: {},
      showQuitTip: false,
      nextRoute: {},
      quitFlag: false
    }
  },
  computed: {
    ...mapState(['user', 'theme']),
    deviceTypes() {
      const { deviceCheckOpen, deviceTypes } = this.theme
      return deviceCheckOpen ? deviceTypes.sort() : []
    }
  },
  mounted() {
    // 刷新页面/关闭页面提示
    this.beforeUnloadFun = (e) => {
      (e || window.event).returnValue = true
    }
    window.addEventListener('beforeunload', this.beforeUnloadFun)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.beforeUnloadFun)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.quitFlag && this.curStep !== 4) {
      this.nextRoute = to.path
      this.showQuitTip = true
      next(false)
    } else {
      next()
    }
  },
  watch: {
    curStep(val) {
      if (val === 4) { // 在检测结果页去掉页面刷新/关闭提示
        window.removeEventListener('beforeunload', this.beforeUnloadFun)
        this.$store.commit('SETSTATE', { key: 'needDetect', value: 0 }) // 关闭设备检测提示
      }
    }
  },
  methods: {
    async nextStep(step) {
      this.loading = true
      try {
        await this.submitDeviceInfo(step)
      } catch (error) {
        this.$message.error('提交检测信息异常，请刷新重试')
        this.loading = false
        return
      }
      this.loading = false
      let newStep = step + 1
      if (this.deviceTypes.length && newStep > 0) { // 根据站点设备检测配置判断是否要跳过步骤
        while (!this.deviceTypes.includes(newStep) && newStep < 4) {
          newStep += 1
        }
      }
      this.curStep = newStep
    },
    async submitDeviceInfo(step) {
      switch (step) {
        case -1: // 回到第一步，初始化检测结果
          this.pcInfo = {}
          break
        case 1:
          await this.handlePcInfo()
          break
        case 2:
          await this.handleCameraInfo()
          break
        case 3:
          await this.handleMicroInfo()
          break
      }
    },
    async handlePcInfo() {
      this.detectOsApi()
      this.detectVersionApi()
      this.detectSpeedApi()
      const reason = `${this.osTip} ${this.versionTip} ${this.speedTip}`
      const params = {
        deviceInfo: JSON.stringify(this.pcInfo),
        deviceStatus: this.detectOs && this.detectVersion && this.detectSpeed ? 1 : 0,
        deviceType: 1,
        reason: reason.trim()
      }
      await this.reportInfo(params)
    },
    async handleCameraInfo() {
      const status = this.pcInfo.camera
      const params = {
        deviceInfo: '',
        deviceStatus: status !== 'i' ? 0 : 1,
        deviceType: 2,
        reason: mediaInfo[status].cameraTip
      }
      await this.reportInfo(params)
    },
    async handleMicroInfo() {
      const status = this.pcInfo.micro
      const params = {
        deviceInfo: '',
        deviceStatus: status !== 'i' ? 0 : 1,
        deviceType: 3,
        reason: mediaInfo[status].audioTip
      }
      await this.reportInfo(params)
    },
    async reportInfo(data) {
      const params = Object.assign(data, {
        serialNumber: this.$store.state.browserFinger
      })
      await post(`/home/devices/check/report`, params)
    },
    setPcInfo(data) {
      this.pcInfo = Object.assign(this.pcInfo, data)
    },
    setCameraInfo(val) {
      this.$set(this.pcInfo, 'camera', val)
    },
    async setMicroInfo (val) {
      this.$set(this.pcInfo, 'micro', val)
      this.nextStep(3)
    },
    // 检测操作系统
    detectOsApi () {
      let os = ''
      if (this.pcInfo.OS === 'Windows') {
        os = this.pcInfo.OS + this.pcInfo.osVersion
        const normalArr = [ 'Windows7', 'Windows8', 'Windows8.1' ] // 一般般
        const errorArr = [ 'Windows', 'Windows2000', 'WindowsXP', 'Windows2003', 'WindowsVista' ] // 不够格
        if (normalArr.indexOf(os) >= 0) {
          this.detectOs = this.status.normal
        } else if (errorArr.indexOf(os) >= 0) {
          this.detectOs = this.status.error
          this.osTip = '操作系统版本过低，请升级到要求的版本'
        } else {
          this.detectOs = this.status.pass
        }
      } else if (this.pcInfo.OS === 'Mac OS') {
        os = this.pcInfo.OS
        const num = this.pcInfo.osVersion.split('.')
        // 一般
        if (Number(num[0]) >= 10 && (Number(num[1]) < 11 && Number(num[1]) >= 9)) {
          this.detectOs = this.status.normal
        } else if ((Number(num[0]) >= 10 && Number(num[1]) >= 11) || Number(num[0]) > 10) { // 好的
          this.detectOs = this.status.pass
        } else { // 异常的
          this.detectOs = this.status.error
          this.osTip = '操作系统版本过低，请升级到要求的版本'
        }
      } else {
        this.detectOs = this.status.error
        this.osTip = '操作系统暂不支持，请升级到Windows7以上版本'
      }
    },
    // 检测浏览器版本
    detectVersionApi () {
      if (this.pcInfo.browser !== 'Chrome') {
        this.detectVersion = this.status.error
        this.versionTip = '请使用最新版本的谷歌浏览器'
        return false
      }
      const version = this.pcInfo.browserVersion.split('/')[1].split('.')[0]
      if (Number(version) >= 78) {
        this.detectVersion = this.status.pass
        return false
      } else if (Number(version) < 70) {
        this.detectVersion = this.status.error
        this.versionTip = '浏览器版本过低，请升级到要求的版本'
        return false
      } else {
        this.detectVersion = this.status.normal
        // this.versionTip = '浏览器版本过低，请升级到要求的版本'
      }
    },
    // 检测网速
    detectSpeedApi () {
      const uploadSpeed = this.pcInfo.uploadSpeed
      const downloadSpeed = this.pcInfo.downloadSpeed
      if (Number(uploadSpeed) >= 0.12 && Number(downloadSpeed) >= 0.12) {
        this.detectSpeed = this.status.pass
        return false
      } else if (Number(uploadSpeed) < 0.12 && Number(downloadSpeed) < 0.12) {
        this.detectSpeed = this.status.error
        this.speedTip = '网速过低，建议更换网络后重试'
        return false
      } else {
        this.detectSpeed = this.status.normal
        // this.speedTip = '网速过低，建议更换网络后重试'
      }
    },
    // 关闭提示
    closeModal() {
      this.quitFlag = false
      this.showQuitTip = false
    },
    // 退出设备检测
    quit() {
      this.quitFlag = true
      this.showQuitTip = false
      this.$router.push({ path: this.nextRoute })
    }
  }
}
</script>

<style lang="scss" scoped>
  .detect {
    height: 100%;
    background-color: #fafafa;
    /deep/ h2 {
      font-weight: 500;
      padding-top: 34px;
    }
  }
  .loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .bg {
    max-width: 1669px;
    min-height: 846px;
    background: url("~@/assets/images/detect/bg.png") center / cover no-repeat;
    margin: 0 auto auto;
    padding-top: 150px;
    overflow: hidden;
  }
  .main-content {
    position: relative;
    width: 1000px;
    min-height: 520px;
    overflow: hidden;
    background-color: #fff;
    margin: 0 auto 80px;
    box-shadow: 0 10px 30px 0 rgba(57, 126, 253, 0.15);
    border-radius: 8px;
    text-align: center;
  }
</style>
